import { useStaticQuery, graphql } from 'gatsby';

const ImageLookup = (contentfulId) => {
  const { allContentfulAsset } = useStaticQuery(
    graphql`
      query {
        allContentfulAsset(filter: {file: {fileName: {regex: "/jp[e]?g|png|gif/"}}}) {
          nodes {
            contentful_id
            fluid(maxWidth: 1450) {
              ...GatsbyContentfulFluid_withWebp
            }
          }
        }
      }
    `,
  );

  if (allContentfulAsset) {
    const asset = allContentfulAsset.nodes.find((a) => a.contentful_id === contentfulId);
    if (asset) {
      return asset.fluid;
    }
  }
  return null;
};

export default ImageLookup;

export const getContentfulGatsbyImage = (id) => {
  // console.log('getting asset', id);
  const asset = ImageLookup(id);
  return asset ? { contentfulId: id, fluid: asset } : {};
};
